"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TripTrackingStatus = void 0;
var TripTrackingStatus;
(function (TripTrackingStatus) {
    TripTrackingStatus["NotTracked"] = "NOT_TRACKED";
    TripTrackingStatus["TrackingStarted"] = "STARTED";
    TripTrackingStatus["TrackingCancelled"] = "CANCELLED";
    TripTrackingStatus["TrackingCompleted"] = "COMPLETED";
})(TripTrackingStatus || (exports.TripTrackingStatus = TripTrackingStatus = {}));
//# sourceMappingURL=trip-tracking-status.enum.js.map